import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const ProfileDetails = Loader(
  lazy(() => import('src/content/Settings/ProfileDetails'))
);

const profileRoutes = [
  {
    path: '/',
    element: <Navigate to="details" replace />
  },
  {
    path: ':tabName',
    element: <ProfileDetails />
  }
];

export default profileRoutes;
